import React, {Component, useState} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { Picker } from 'emoji-mart';
import { Paper, Button, TextField, Tabs } from 'components'
import { FileInput } from 'features'

import * as actionCreators from 'store/actions'
import classes from './ImageInput.module.css'

class ImageInput extends Component {
    constructor(props){
        super(props);
        this.tabOptions = {
            link: 'Link',
            file: 'File'
        }
        this.state = {
            tab: 'link',
            value: ''
        }

        this.tabStyles = {
            main: {
                backgroundColor: 'var(--secondary-color)',
            },
            tab: {
                width: '4rem',
                // backgroundColor: 'var(--secondary-color)'
            }
        }
    }

    onSubmitLinkHandler = (link) => {
        console.log(link)
        this.props.onSubmit(link || this.state.value, this.state.tab)
        // this.props.onClose && this.props.onClose()
        this.props.closeHandler && this.props.closeHandler()
    }

    onRemoveHandler = () => {
        this.props.onSubmit(null, null)
        this.props.onClose && this.props.onClose()
        this.props.closeHandler && this.props.closeHandler()
    }

    keypressHandler = (event) => {
        // Enter
        if (event.charCode === 13) {
            if(!this.state.value ? false : this.state.value.length > 0){
                this.props.onSubmit(this.state.value, this.state.tab)
                this.props.onClose && this.props.onClose()
                this.props.closeHandler && this.props.closeHandler()
            }
        } 
        else if (event.keyCode === 27 ) {
            this.setState({
                value: null
            })
            this.props.onClose && this.props.onClose()
            this.props.closeHandler && this.props.closeHandler()
        } 
    }

    render() {
        let selector = null;
        if (this.state.tab === 'link') {
            selector = <div className={classes.LinkInput}>
                            <div className={classes.TextContainer}>
                                <TextField type='single' onChange={(event) => this.setState({value: event.target.value})} value={this.state.value} placeholder='Paste an image link' focus autoFocus
                                    onKeyPress={this.keypressHandler} onKeyDown={this.keypressHandler}/>
                            </div>
                            <div className={classes.ButtonsContainer}>
                                <Button valid={!this.state.value ? false : this.state.value.length > 0 ? true : false} text='Submit' onSelect={(event) => this.onSubmitLinkHandler(this.state.value)}
                                    disable={!this.state.value ? false : this.state.value.length === 0} styles={{backgroundColor: 'var(--focus-color)', color: 'white', margin: 0, fontWeight: 'bolder'}}/>
                            </div>
                        </div>   
        } 
        else if (this.state.tab === 'file'){
            selector = <div className={classes.FileInput}><FileInput placeholder='Drop your image here' fileWarnings='Only image files allowed' onSubmit={this.onSubmitLinkHandler}/></div>
        }
        return (
            <Paper>
                <div className={classes.IconInput}>
                    <div className={classes.Header}>
                        <Tabs styles={this.tabStyles} options={this.tabOptions} selected={this.state.tab} onSelect={(tab) => this.setState({tab: tab})}/>
                        <Button text='Remove' onSelect={this.onRemoveHandler} styles={{backgroundColor: 'var(--secondary-color)', boxShadowColor: 'transparent', fontWeight: 'bolder'}}/>
                    </div>
                    {selector}
                </div>
            </Paper>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        success: state.auth.success,
        error: state.auth.error
    }
};

const mapDispatchToProps = dispatch => {
    return {

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageInput);